import Awesomplete from 'awesomplete';

function completeOnSelect() {
  document.getElementById('site-search-submit').click();
}

function autocomplete() {
  const endpoint =
    (typeof guidedogsGlobals === 'object' &&
      `${guidedogsGlobals.gdresturl}search-preload`) ||
    '';
  const siteSearchInput = document.getElementById('site-search');

  if (siteSearchInput) {
    const searchList = [];

    const navigationMenuButton = document.querySelector(
      '#navigation-header-toggle',
    );

    navigationMenuButton &&
      navigationMenuButton.addEventListener('click', () => {
        if (searchList.length === 0) {
          fetch(endpoint)
            .then((response) => response.json())
            .then((data) =>
              data.forEach((title) => {
                searchList.push(title);
              }),
            );

          new Awesomplete(siteSearchInput, {
            list: searchList,
          });

          Awesomplete.$.bind(siteSearchInput, {
            'awesomplete-selectcomplete': completeOnSelect,
          });

          const searchListElem = document.querySelector(
            '[id*="awesomplete_list_"]',
          );

          searchListElem.setAttribute('aria-hidden', 'true');

          siteSearchInput.addEventListener('awesomplete-open', () => {
            searchListElem.setAttribute('aria-hidden', 'false');
          });

          siteSearchInput.addEventListener('awesomplete-close', () => {
            searchListElem.setAttribute('aria-hidden', 'true');
          });
        }
      });

    // Create a condition that targets viewports at least 768px wide
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const placeholderMain = siteSearchInput.getAttribute('data-placeholder');
    const placeholderDevice = siteSearchInput.getAttribute(
      'data-placeholder-device',
    );

    function handleTabletChange(e) {
      // Check if the media query is true
      if (e.matches) {
        // Then log the following message to the console
        siteSearchInput.setAttribute('placeholder', placeholderMain);
      } else {
        siteSearchInput.setAttribute('placeholder', placeholderDevice);
      }
    }

    // Register event listener
    mediaQuery.addListener(handleTabletChange);

    // Initial check
    handleTabletChange(mediaQuery);
  }
}

export function init() {
  autocomplete();
}
